import { useEffect, useState } from "react";

/** Tailwind `sm` breakpoint — keep in sync with toolbar vs sticky Share placement. */
export const SM_UP_QUERY = "(min-width: 640px)";

/**
 * Subscribe to a CSS media query. Initial value reads `window` when available
 * (CRA client render) so desktop does not flash the mobile Share footer.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    function onChange() {
      setMatches(mql.matches);
    }
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
